import { useEffect } from "react";
import {navigate} from "../../../../../../services/navigation/navigation";
import {appPagePaths} from "../../../../../../config/config";
import mySongsLibrary from "../../../../../../services/songs/songsPage";

export interface ISongDetailsEmptyLessonResultsMessageLogic {
  navigateToSongsPageOnClick: () => void;
}


export const useSongDetailsEmptyLessonResultsMessageLogic = (): ISongDetailsEmptyLessonResultsMessageLogic => {
  const navigateToSongsPageOnClick = () =>
    navigate(appPagePaths.songsPage);

  useEffect(() => {
    mySongsLibrary.reset();
  }, []);

  return {navigateToSongsPageOnClick};
}
